import type { ClientTeamSearchRow } from '@/api/beatlyApi';

/**
 * Stable A–Z sort for team names (UI lists). Uses Swedish locale for Nordic brand names;
 * `sensitivity: 'base'` ignores case for ordering.
 */
export function sortClientTeamsByName(teams: ClientTeamSearchRow[]): ClientTeamSearchRow[] {
  return [...teams].sort((a, b) => {
    const na = (a.name ?? a.team_id ?? '').trim();
    const nb = (b.name ?? b.team_id ?? '').trim();
    return na.localeCompare(nb, 'sv', { sensitivity: 'base' });
  });
}
